import PropTypes from "prop-types";

/**
 * Chart Data Point Shape
 * Shape for individual data points in charts
 *
 * @typedef {Object} ChartDataPoint
 * @property {string|number} [x] - X-axis value
 * @property {number} [y] - Y-axis value
 * @property {string} [label] - Optional label for the data point
 */
export const chartDataPointShape = PropTypes.shape({
  x: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  y: PropTypes.number,
  label: PropTypes.string,
});

/**
 * Chart Series Shape
 * Shape for chart data series
 *
 * @typedef {Object} ChartSeries
 * @property {string} [name] - Series name for legend
 * @property {Array<number|ChartDataPoint>} [data] - Array of data values or data point objects
 * @property {string} [color] - Series color (hex or CSS color)
 */
export const chartSeriesShape = PropTypes.shape({
  name: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, chartDataPointShape])),
  color: PropTypes.string,
});
